export default __webpack_public_path__ + "static/media/tcs3.55a731ed.jpeg";